import { IEgSupportedConfig, apiService, examGeneratorDB } from '..';

export const fetchExamGeneratorSupportedConfig = async (): Promise<boolean> => {
  try {
    const response = await apiService.get<IEgSupportedConfig>(
      `/api/v1/ug-eg/supported-config/?c=${Date.now()}`,
    );
    await examGeneratorDB.transaction(
      'rw',
      examGeneratorDB.egSupportedSubjects,
      async () => {
        await examGeneratorDB.egSupportedSubjects.clear();
        await examGeneratorDB.egSupportedSubjects.bulkPut(
          response.data.subjects,
        );
      },
    );
    return true;
  } catch (e) {
    console.error('Failed to fetch EG supported config', e);
    return false;
  }
};
